import { Route, Routes } from 'react-router-dom';

import { AppShell } from '@/components/layout/app-shell';
import { AboutPage } from '@/pages/about';
import { CancerNavigatorPage } from '@/pages/cancer-navigator';
import { ContactPage } from '@/pages/contact';
import { DonatePage } from '@/pages/donate';
import { GetInvolvedPage } from '@/pages/get-involved';
import { GraceAiPage } from '@/pages/grace-ai';
import { HomePage } from '@/pages/home';
import { MyStoryPage } from '@/pages/my-story';
import { NextOnVeraPage } from '@/pages/nextonvera';
import { PlaceholderPage } from '@/pages/placeholder-page';
import { PrivacyPage } from '@/pages/privacy';
import { TermsOfUseMedicalInfoPage } from '@/pages/terms-of-use';
import { TheFundPage } from '@/pages/the-fund';
import { WhyTdcNextOnVeraPage } from '@/pages/why-tdc-nextonvera';

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="nextonvera" element={<NextOnVeraPage />} />
        <Route path="cancer-navigator" element={<CancerNavigatorPage />} />
        <Route path="grace-ai" element={<GraceAiPage />} />
        <Route path="my-story" element={<MyStoryPage />} />
        <Route path="the-fund" element={<TheFundPage />} />
        <Route path="why-tdc-nextonvera" element={<WhyTdcNextOnVeraPage />} />
        <Route path="get-involved" element={<GetInvolvedPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="donate" element={<DonatePage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="termsofuse-medicalinfo" element={<TermsOfUseMedicalInfoPage />} />
        <Route
          path="*"
          element={
            <PlaceholderPage
              title="Page not found"
              description="That path is not part of the NextOnVera microsite yet."
            />
          }
        />
      </Route>
    </Routes>
  );
}
